import { api, Api } from '@/services/api';
import type { Game, ListResult, Platforms, Profile } from '@/types';

const gamesEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    games: builder.query<Game[], void>({
      query: () => ({ url: Api.Games }),
      providesTags: ['Games'],
    }),
    platforms: builder.query<Platforms[], void>({
      query: () => ({ url: Api.Platforms }),
    }),
    favoriteGames: builder.query<Game[], number>({
      query: (id) => ({ url: Api.FavoriteGames.replace(':id', id.toString()) }),
    }),
    profiles: builder.query<ListResult<Profile>, number>({
      query: (id) => ({ url: Api.Profiles.replace(':id', id.toString()) }),
      providesTags: ['Profiles'],
    }),
    profileId: builder.query<Profile, { id: number; profileId: number }>({
      query: (params) => ({
        url: Api.ProfilesId.replace(':id', params.id.toString()).replace(
          ':profileId',
          params.profileId.toString(),
        ),
      }),
    }),
  }),
});

export const {
  useGamesQuery,
  useLazyGamesQuery,
  usePlatformsQuery,
  useFavoriteGamesQuery,
  useProfilesQuery,
  useProfileIdQuery,
} = gamesEndpoints;
